import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import About from "./components/About";
import Contact from "./components/Contact";
import Carousel from "./components/Carousel";
import LocalBusinessSchema from "./schemas/LocalBusinessSchema";
import OrganizationSchema from "./schemas/OrganizationSchema";
import ServiceSchema from "./schemas/ServiceSchema";
import { Helmet } from "react-helmet";

const App = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);

    window.addEventListener("resize", handleResize);

    const scrollTimeout = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    return () => {
      clearTimeout(scrollTimeout);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Belle Epoque - Agência de Viagens</title>
        <meta
          name="description"
          content="Belle Epoque é a sua Agência de Viagens de eleição!"
        />
        <meta
          name="keywords"
          content="agência de viagens, agência, viagens, férias, escapadinhas, planeamento, packs de viagens, orçamentos, hoteis, voos, travel, holidays, trips, Figueira da Foz"
        />
        <meta property="og:title" content="Belle Epoque - Agência de Viagens" />
        <meta
          property="og:description"
          content="Tudo o que tem de saber sobre a Belle Epoque - Agência de Viagens!"
        />
      </Helmet>

      <OrganizationSchema></OrganizationSchema>
      <LocalBusinessSchema></LocalBusinessSchema>
      <ServiceSchema serviceName={"Venda de Viagens"}></ServiceSchema>
      <ServiceSchema serviceName={"Orçamentos"}></ServiceSchema>
      <ServiceSchema serviceName={"Planeamentos de Viagens"}></ServiceSchema>
      <ServiceSchema serviceName={"Packs de Viagens"}></ServiceSchema>

      <div className="min-h-screen overflow-x-hidden font-nunito">
        <div id="nextSection" className="bg-transparent">
          <Header />
          {isDesktop && <Carousel />}
          <div
            id="about"
            style={{
              paddingTop: isDesktop ? "0px" : "60px", // Apply margin-top on mobile
            }}
          >
            <About />
          </div>
          <div id="contact">
            <Contact />
          </div>
        </div>
      </div>
    </>
  );
};

export default App;
